import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../styles/theme';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.secondary} 100%);
  color: ${theme.colors.white};
`;

const LogoContainer = styled.div`
  animation: ${fadeIn} 1s ease-out;
  margin-bottom: ${theme.spacing.xl};
`;

const Logo = styled.div`
  font-size: 4rem;
  font-weight: bold;
  text-align: center;
  animation: ${pulse} 2s ease-in-out infinite;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 3rem;
  }
`;

const Subtitle = styled.div`
  font-size: 1.2rem;
  opacity: 0.9;
  text-align: center;
  margin-top: ${theme.spacing.md};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1rem;
  }
`;

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid ${theme.colors.white};
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-top: ${theme.spacing.xl};
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const SplashScreen: React.FC = () => {
  return (
    <Container>
      <LogoContainer>
        <Logo>971 RUN</Logo>
        <Subtitle>Premium Car Wash Services</Subtitle>
      </LogoContainer>
      <LoadingSpinner />
    </Container>
  );
};

export default SplashScreen;


